import {
  ADD_ADVERTISEMENT,
  EDIT_ADVERTISEMENT,
  GET_ADVERTISEMENTS,
  REMOVE_ADVERTISEMENT,
  GET_ADVERTISEMENT_BY_ID,
} from "../actions/cooperation-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const cooperationReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (ADD_ADVERTISEMENT.REQUEST,
    GET_ADVERTISEMENTS.REQUEST,
    GET_ADVERTISEMENT_BY_ID.REQUEST,
    EDIT_ADVERTISEMENT.REQUEST,
    REMOVE_ADVERTISEMENT.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_ADVERTISEMENT.SUCCESS,
    GET_ADVERTISEMENTS.SUCCESS,
    GET_ADVERTISEMENT_BY_ID.SUCCESS,
    EDIT_ADVERTISEMENT.SUCCESS,
    REMOVE_ADVERTISEMENT.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_ADVERTISEMENT.FAILURE,
    GET_ADVERTISEMENTS.FAILURE,
    GET_ADVERTISEMENT_BY_ID.FAILURE,
    EDIT_ADVERTISEMENT.FAILURE,
    REMOVE_ADVERTISEMENT.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { cooperationReducer };
